export default __webpack_public_path__ + "static/media/Primary-PDF.60c773aa.svg";